import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orders-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Мои заказы", -1)),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: _ctx.orders,
      style: {"width":"100%"},
      "empty-text": "Нет заказов"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "order_number",
          label: "ID заказа",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.order_number + 1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "currency",
          label: "Валюта",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "Сумма",
          width: "120"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.amount?.toFixed(4) || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sender.name",
          label: "Отправитель"
        }),
        _createVNode(_component_el_table_column, {
          prop: "payee.name",
          label: "Получатель"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_ru",
          label: "Статус",
          width: "80"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "Дата создания",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.created_at)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Действия",
          width: "80"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              icon: "Edit",
              circle: "",
              size: "small",
              onClick: ($event: any) => (_ctx.editOrder(row))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _ctx.loading]
    ])
  ]))
}